import $ from 'jquery'
import { prepareChessboard, loadNextConfiguration, showMagnus, restrictMove, validateMove, validatePosition, validateDrop, validateDrag, plotArrow } from '../../utils';
import ChessBoard from '../../components/chessBoard';
import { CORRECT_ANSWER_AUDIO, WRONG_ANSWER_AUDIO, ACTIVITY_COMPLETION_AUDIO } from '../../utils/constants';
import User from '../../classes/user';

/**
* @name lesson16Assignment1
* @function
* @param {config}
* @description: activity related task
*/
export function lesson16Assignment1(config) {
  let next = config.next;
  let callback = function () {
    let body = `
        <div class='card flex-center'>
          <div class='card-wrapper full-width'>
            <ul class='options-table'>
            <span><img class='imgArrows' src='/img/lesson16Activity.png'></span>
            <div class='question-mark'>
            <span id='AnswerOne'> ? </span>
            <span id='AnswerTwo'> ? </span>
            </div>
            <span class='checkbox1'><input type='text' id='checkbox1' class='NumberBoxInput'></span>
              <span class='plus1'>+</span>
              <span class='checkbox2'><input type ='text' id='checkbox2' class='NumberBoxInput'></span>
              <span class='equal-1'>=</span>
              <span class='checkbox3'><input type ='text' id='checkbox3' class='NumberBoxInput'></span>
              <span><img class='imgArrow' id='imgSix' src='/img/arrow_six.png'></span>
              <span class='checkbox4'><input type='text' id='checkbox4' class='NumberBoxInput'></span>
              <span class='plus2'>+</span>
              <span class='checkbox5'><input type ='text' id='checkbox5' class='NumberBoxInput'></span>
              <span class='equal-2'>=</span>
              <span class='checkbox6'><input type ='text' id='checkbox6' class='NumberBoxInput'></span>
              <span><img class='imgArrow' id='imgSeven'src='/img/arrow_seven.png'></span>
            </ul>
          </div>
        </div>`;
    $('.activity-section-content').html(body);
    var inputOne, inputTwo, resultOne, inputThree, inputFour, resultTwo;
    $(document).ready(function () {
      $('.directions').addClass('directions-lesson16-activity1');
      $('.right-box-content').addClass('right-box-lesson16-activity1')
      $('#checkbox4').prop('disabled', true);
      $('#checkbox5').prop('disabled', true);
      $('#checkbox6').prop('disabled', true);
      $('#checkbox1').keyup(function () {
        inputOne = this.value;
      })
      $('#checkbox2').keyup(function () {
        inputTwo = this.value;
        GetValuesOf()
      })
      $('#checkbox4').keyup(function () {
        inputThree = this.value;
      })
      $('#checkbox5').keyup(function () {
        inputFour = this.value;
        ResultValue()
      })
      $('.next-btn-container #next, .back-btn-container #previous').click(function () {
        $('.directions').removeClass('directions-lesson16-activity1');
        $('.right-box-content').removeClass('right-box-lesson16-activity1');
        $('.speech-bubble').removeClass();
      })

      function GetValuesOf() {
        if (inputOne && inputTwo) {
          $('#checkbox3').on("input", function (event) {
            resultOne = this.value;
            if ($(this).val().length >= 2 ) {
              resultOneValue()
            }
          })
        }
      }
      function resultOneValue() {
        if (resultOne === '13') {
          if (inputOne === '5' && inputTwo === '8' && resultOne === '13') {
            $('#AnswerOne').text(resultOne);
            showMagnus({
              data: `Nice job!` + User.user.name + `<br/>Fill the next series <br/> to continue the pattern`,
              position: 'right',
              styleClass: 'sm'
            })
            $('#checkbox4').prop('disabled', false);
            $('#checkbox5').prop('disabled', false);
            $('#checkbox6').prop('disabled', false);
          }
          else if ((inputOne !== '5' || inputTwo !== '8') && resultOne === '13') {
            showMagnus({
              data: 'Oops...!!!Try again. Look at the series and give appropriate values',
              position: 'right',
              styleClass: 'md',
              timeout: 1000,
            })
            setTimeout(function () {
              $('.speech-bubble').remove();
            }, 5000)
            setTimeout(function() {
              $('#checkbox1').val('')
              $('#checkbox2').val('')
              $('#checkbox3').val('')
            }, 3000)
          }
        }
        else {
          showMagnus({
            data: 'Oops...!!!Try again. Look at the series and give appropriate values',
            position: 'right',
            styleClass: 'md',
            timeout: 1000,
          })
          setTimeout(function () {
            $('.speech-bubble').remove();
          }, 5000)
          setTimeout(function() {
            $('#checkbox1').val('')
            $('#checkbox2').val('')
            $('#checkbox3').val('')
          }, 3000)
        }
      }
      function ResultValue() {
        if (inputThree && inputFour) {
          $('#checkbox6').on("input", function (event) {
            if($(this).val().length >= 2) {
              resultTwo = this.value;
              resultTwoValue();
            }
          })
        }
      }
      function resultTwoValue() {
        if (resultTwo === '21') {
          if (inputThree === '8' && inputFour === '13' && resultTwo === '21') {
            $('#AnswerTwo').text(resultTwo);
            showMagnus({
              data: `Nice job!` + User.user.name,
              position: 'right',
              styleClass: 'sm'
            })
            setTimeout(function () {
              $('.right-box-content').removeClass('right-box-lesson16-activity1');
              $('.speech-bubble').removeClass()
            }, 3000);
            loadNextConfiguration(3000, next, true)
          }
          else if((inputThree !== '8' || inputFour !== '13') && resultTwo === '21'){
          showMagnus({
            data: 'Oops...!!!<br/> Try again. Look at the series and give appropriate values',
            position: 'right',
            styleClass: 'sm',
            timeout: 1000,
          })
          setTimeout(function () {
            $('.speech-bubble').remove();
          }, 5000)
          setTimeout(function() {
            $('#checkbox4').val('')
            $('#checkbox5').val('')
            $('#checkbox6').val('')
          }, 3000)  
          }
        }
        else {
          showMagnus({
            data: 'Oops...!!!<br/> Try again. Look at the series and give appropriate values',
            position: 'right',
            styleClass: 'sm',
            timeout: 1000,
          })
          setTimeout(function () {
            $('.speech-bubble').remove();
          }, 5000)
          setTimeout(function() {
            $('#checkbox4').val('')
            $('#checkbox5').val('')
            $('#checkbox6').val('')
          }, 3000)
        }
      }
    })
  }
  return callback;
}

/**
* @name lesson16Activity2
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/
export function lesson16Activity2(config) {
  let next = config.next,
    pieceLimit = config.pieceLimit,
    piecesArray = config.piecesArray ? config.piecesArray : [],
    validatePieces = config.validatePieces ? config.validatePieces : [],
    draggedNumbersCount = 0;

  let afterLoad = function () {
    prepareChessboard(config);
    $('.back-btn-container #previous').click(function () {
      $('.card-wrapper.activity').remove();
    });
    $('.next-btn-container #next').click(function () {
      $('.card-wrapper.activity').remove();
    })
    $('.square-c3').prepend('<img id="imgOne" src="/img/chesspieces/assignment_16_2/bQ.png" />')
    let body = `<div class='card flex-center'>
    <div class='card-wrapper activity'>
    </div>
  </div>`;
    $('.chessboard').addClass('flex-display')
    $('.left-box-content').html(body);
    $('.card.flex-center').addClass('left-section-lesson16');
    $('.spare-pieces-7492f.spare-pieces-top-4028b').addClass('margin-lesson16');
    $('.spare-pieces-7492f.spare-pieces-bottom-ae20f').addClass('margin-left-lesson16');
    $('.chessboard-63f37').addClass('margin-right-lesson16');
  }

  let onDragStart = function (source, piece, position, orientation) {
    validateDrag(piece, pieceLimit[piece])
  };

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let bubbleConfig = {
      data: 'Good Job',
      position: 'left',
      styleClass: 'xs'
    };

    validatePosition(piecesArray.length, next, bubbleConfig, false, true)
    var dropValidation = validateDrop(piece, pieceLimit[piece], target, validatePieces, true)
    if (dropValidation === 'trash' && draggedNumbersCount === 8) {
      showMagnus({
        data: 'Try again! <br/>That was not the correct order.',
        position: 'left',
        styleClass: 'sm',
        timeout: '500'
      })
      $('.piece-417db').remove();
      draggedNumbersCount = 0;
      loadNextConfiguration(4000, config.repeatActivity, true)
    }
    return dropValidation
  }

  var onSnapEnd = function (source, target, piece) {
    draggedNumbersCount++
    if (config.resultFen.includes(ChessBoard.board.fen())) {
      showMagnus({
        data: 'Nice job! <br/>' + User.user.name,
        position: 'left',
        styleClass: 'xs',
        timeout: 1000,
      })
      loadNextConfiguration(4000, next, true)
      $('.card-wrapper.activity').remove();
    }
    else if ((!config.resultFen.includes(ChessBoard.board.fen()) && draggedNumbersCount === 9)) {
      showMagnus({
        data: 'Try again!<br/>That was not the correct order.',
        position: 'left',
        styleClass: 'sm',
        timeout: 500
      })
      draggedNumbersCount = 0;
      loadNextConfiguration(4000, config.repeatActivity, true)
    }
  }

  const chessConfig = {
    config: {
      draggable: true,
      dropOffBoard: 'trash',
      sparePieces: true,
      onDrop: onDrop,
      onDragStart: onDragStart,
      onSnapEnd: onSnapEnd,
      pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.png`
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


/**
* @name lesson16Assignment3
* @function
* @param {config}
* @description: activity related task
*/
export function lesson16Assignment3(config) {

  let afterLoad = function () {
    let next = config.next,
      coordinatesGreen = config.coordinatesGreen ? config.coordinatesGreen : [],
      coordinatesYellow = config.coordinatesYellow ? config.coordinatesYellow : [],
      coordinatesPurple = config.coordinatesPurple ? config.coordinatesPurple : [],
      coordinateCountGreen = coordinatesGreen.length,
      coordinateCountYellow = coordinatesYellow.length,
      coordinateCountPurple = coordinatesPurple.length,
      nonePointerGreen = config.coordinateNonePointerGreen ? config.coordinateNonePointerGreen : [],
      nonePointerYellow = config.coordinateNonePointerYellow ? config.coordinateNonePointerYellow : [],
      nonePointerPurple = config.coordinateNonePointerPurple ? config.coordinateNonePointerPurple : [];

    var correctClick = false,
      CheckedGreen = false,
      CheckedYellow = false,
      CheckedPurple = false;

    var board = document.getElementsByClassName('chessboard-63f37');
    $(board[0]).click(function (e) {
      e.preventDefault();
      if (!correctClick) {
        $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
        showMagnus({
          data: 'oops! <br/> Wrong square',
          styleClass: 'xs'
        })
      }
      correctClick = false;
    })
    let body = `
            <div class = "wrapActivity3">
            <div class='flex-display flex-column'>
            <label id='labelOne' class='container'><p class='hideLabel'>1.</p>
            <input class='checkBoxAssignment16' type='checkbox' id ='checkBox1' disabled='disabled'>
            <span class='checkmark'><div class='numbersCheckbox' id='numbersCheckbox1'>1.</div></span>
            </label>
            <label id='labelTwo' class='container'><p class='hideLabel'>2.</p>
            <input class='checkBoxAssignment16' type='checkbox' id ='checkBox2' disabled='disabled'>
            <span class='checkmark'><div class='numbersCheckbox' id='numbersCheckbox2'>2.</div></span>
            </label>
            <label id ='labelThree' class='container'><p class='hideLabel'>3.</p>
            <input class='checkBoxAssignment16' type='checkbox' id ='checkBox3' disabled='disabled'>
            <span class='checkmark'><div class='numbersCheckbox' id='numbersCheckbox3'>3.</div></span>
            </label>
            </div>
            </div>`;

    $(function () {
      $('.right-box-content').append(body)
    })

    prepareChessboard(config);

    if (coordinateCountYellow === 0) {
      CheckedYellow = true;
      checkBoxes(CheckedYellow)
      $('#checkBox2').attr('checked', true)
      setTimeout(function () {
        $(function () {
          $('#labelTwo').hide()
        })
      })
    }

    if (coordinateCountPurple === 0) {
      CheckedPurple = true;
      checkBoxes(CheckedPurple)
      $('#checkBox3').attr('checked', true)
      $('#labelThree').hide()
      setTimeout(function () {
        $(function () {
          $('#labelThree').hide()
        })
      })
    }

    coordinatesGreen.forEach(element => {
      $(element).click(function () {
        $(this).addClass('none-pointer-event');
        correctClick = true;
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
        $(this).css('background-color', '#FFDF00');
        --coordinateCountGreen;
        if (coordinateCountGreen === 0) {
          showMagnus({
            data: 'Good job! <br/>' + User.user.name,
            styleClass: 'xs'
          })
        }
        if (coordinateCountGreen === 0) {
          nonePointerGreen.forEach(element => {
            $(element).addClass('none-pointer-event');
          })
          $('#checkBox1').attr('checked', true)
          addTick();
          setTimeout(function () {
            coordinatesGreen.forEach(element => {
              $(element).css('background', '')
            })
          }, 500)
          CheckedGreen = true;
          checkBoxes(CheckedGreen)
        }
      })
    });

    coordinatesYellow.forEach(element => {
      $(element).click(function () {
        correctClick = true;
        if (config.idCommon === false) {
          $(this).addClass('none-pointer-event')
        }
        if (element === '.square-h6' || element === '.square-g7') {
          $('.square-d5').addClass('none-pointer-event');
        }
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
        $(this).css('background-color', '#FFDF00');
        --coordinateCountYellow;
        if (coordinateCountYellow === 0) {
          showMagnus({
            data: 'Good job! <br/>' + User.user.name,
            styleClass: 'xs'
          })
        }
        if (coordinateCountYellow === 0) {
          if (config.idCommon) {
            $('.square-d5').addClass('auto-pointer-event')
          }
          else {
            $('.square-d5').addClass('none-pointer-event');
          }
          nonePointerYellow.forEach(element => {
            $(element).addClass('none-pointer-event');
          })
          coordinateCountPurple = 4;
          $('#checkBox2').attr('checked', true)
          addTick()
          setTimeout(function () {
            coordinatesYellow.forEach(element => {
              $(element).css('background', '')
            })
          }, 500)
          CheckedYellow = true;
          checkBoxes(CheckedYellow)
        }
      })
    });

    coordinatesPurple.forEach(element => {
      $(element).click(function () {
        correctClick = true;
        if (element === '.square-d5') {
          $('.square-h6').addClass('none-pointer-event');
          $('.square-g7').addClass('none-pointer-event');
        }
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
        $(this).css('background-color', '#FFDF00');
        --coordinateCountPurple;
        if (coordinateCountPurple === 0) {
          showMagnus({
            data: 'Good job! <br/>' + User.user.name,
            styleClass: 'xs'
          })
        }
        if (coordinateCountPurple === 0) {
          nonePointerPurple.forEach(element => {
            $(element).addClass('none-pointer-event');
          })
          $('.square-h6').addClass('auto-pointer-event');
          $('.square-g7').addClass('auto-pointer-event');
          coordinateCountYellow = 4
          $('#checkBox3').attr('checked', true)
          addTick();
          setTimeout(function () {
            coordinatesPurple.forEach(element => {
              $(element).css('background', '')
            })
          }, 500)
          CheckedPurple = true;
          checkBoxes(CheckedPurple)
        }
      })
    });

    function checkBoxes() {
      if (CheckedGreen === true && CheckedYellow === true && CheckedPurple === true) {
        setTimeout(function () {
          $('#labelOne').remove()
          $('#labelTwo').remove()
          $('#labelThree').remove()
        }, 2000)
        $(document).trigger('audio-play', ACTIVITY_COMPLETION_AUDIO)
        setTimeout(function () {
          $('.wrapActivity3').remove()
        }, 2000)
        $('.tick').removeClass()
        loadNextConfiguration(2000, next, true)
      }
    }

    function addTick() {
      if ($('.tick').length === 0) {
        $('#numbersCheckbox1').html('')
        $('#numbersCheckbox1').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');;
      }
      else if ($('.tick').length === 1) {
        $('#numbersCheckbox2').html('')
        $('#numbersCheckbox2').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');
      }
      else {
        $('#numbersCheckbox3').html('')
        $('#numbersCheckbox3').prepend('<img class="tick" style="height: 100%; width: 100%;" src="/img/tick.svg" />');
      }
    }
    $('#previous').click(function () {
      $('.wrapActivity3').remove()
      $('#labelOne').hide()
      $('#labelTwo').hide()
      $('#labelThree').hide()
    });
    $('#next').click(function () {
      $('.directions').addClass('.directions-lesson16-activity3')
      $('.wrapActivity3').remove()
      $('#labelOne').hide()
      $('#labelTwo').hide()
      $('#labelThree').hide()
    });
  }

  const chessConfig = {
    config: {
      position: config.position,
      draggable: false,
      sparePieces: false
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}

/**
* @name lesson16Assignment4
* @function
* @param {config}
* @description: activity related task
*/
export function lesson16Assignment4(config) {
  let next = config.next,
    moveSpeed = 1000,
    initialBoardPosition = config.position,
    moves = config.moves,
    totalStudentMoves = config.moves.studentMove.from.length,
    totalComputerMoves = config.moves.computerMove.from.length,
    studentFromCount = 0,
    studentToCount = 0,
    computerFromCount = 0,
    computerToCount = 0,
    board, timer,
    offsetFromx = null,
    offsetFromy = null,
    offsetTox = null,
    offsetToy = null;

  if (config.offset) {
    offsetFromx = config.offset[0]
    offsetFromy = config.offset[1]
    offsetTox = config.offset[2]
    offsetToy = config.offset[3]
  };

  let afterLoad = function () {
    prepareChessboard(config);
    $('#myCanvas').addClass('width-lesson16Activity4');
    if (config.firstMove) {
      computerMove();
    }
  }

  let onDragStart = function (source, piece, position, orientation) {
    board = ChessBoard.board.fen();
    return restrictMove(piece, config.restrictMoveOf);
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateMove(source, target, piece, false);
  }

  var onSnapEnd = function (source, target, piece) {
    $('.next-btn-container #next').click(function () {
      studentFromCount = 0;
      studentToCount = 0;
      clearTimeout(timer);
    });
    $('.back-btn-container #previous').click(function () {
      studentFromCount = 0;
      studentToCount = 0;
      clearTimeout(timer);
    })
    if (studentFromCount < totalStudentMoves && studentToCount < totalStudentMoves) {
      if (source === moves.studentMove.from[studentFromCount] && target === moves.studentMove.to[studentToCount]) {
        $(document).trigger('audio-play', CORRECT_ANSWER_AUDIO);
        if (studentToCount === 2) {
          $('#myCanvas').removeClass('width-lesson16Activity4');
          $('#myCanvas').addClass('show').removeClass('hide');
          var c = document.getElementById("myCanvas");
          var ctx = c.getContext("2d");
          ctx.clearRect(0, 0, c.width, c.height);
          plotArrow(ctx, config.fromArrow, config.toArrow, offsetFromx, offsetFromy, offsetTox, offsetToy, null, null, "#cc0000");
          showMagnus({
            data: `Nice job ${User.user.name}! <br/> You made it checkmate`
          })
        }
        setTimeout(function () {
          $(document).trigger('bubble-hide');
        }, 2000)
        studentFromCount++;
        studentToCount++;
        computerMove();
      } else {
        $(document).trigger('audio-play', WRONG_ANSWER_AUDIO);
        showMagnus({
          data: 'That\'s not the right move',
          position: 'left',
          styleClass: 'md'
        })
        setTimeout(function () {
          $(document).trigger('bubble-hide');
        }, 3000)
        ChessBoard.board.position(board);
        ChessBoard.game = new window.Chess(board + config.initialMoveOf);
      }
    }
  }

  function computerMove() {
    if (computerFromCount < totalComputerMoves && computerToCount < totalComputerMoves) {
      timer = setTimeout(function () {
        ChessBoard.board.move(moves.computerMove.from[computerFromCount] + '-' + moves.computerMove.to[computerToCount]);
        computerFromCount++;
        computerToCount++;
      }, 2000);
      $('.next-btn-container #next').click(function () {
        computerFromCount = 0;
        computerToCount = 0;
        clearTimeout(timer);
      });
      $('.back-btn-container #previous').click(function () {
        computerFromCount = 0;
        computerToCount = 0;
        clearTimeout(timer);
      })
    }
    if (!moves.computerMove.from[computerFromCount]) {
      setTimeout(function () {
        studentFromCount = studentToCount = computerFromCount = computerToCount === 0;
        ChessBoard.board.position(config.resultFen);
        loadNextConfiguration(3000, next, true);
      }, 2000);
    } else {
      let boardFen = ChessBoard.board.fen();
      ChessBoard.board.position(boardFen);
      ChessBoard.game = new window.Chess(boardFen + config.initialMoveOf);
    }
  }

  const chessConfig = {
    config: {
      position: initialBoardPosition,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      draggable: true,
      sparePieces: true,
      moveSpeed: moveSpeed
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


/**
* @name lesson16Activity5
* @function
* @param {config}
* @description: to fill squares with color
*/
export function lesson16Activity5(config) {
  let square = config.highlightSquares;
  let afterLoad = function () {
    prepareChessboard(config);
    square.forEach(element => {
      $(element).addClass('background-red');
    })
  }

  const chessConfig = {
    config: {
      position: config.position
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}




// WEBPACK FOOTER //
// ./src/lessons/lesson_16/assignments.js